import React from 'react';
import ReactDOM from 'react-dom/client';
import { initializeLaunchDarkly } from 'ui';
import { enableMockServiceWorker } from '@shared/libs/msw';
import { enableProLicenseMUI } from '@shared/libs/MUI/index.ts';
import { initializeSentry } from '@shared/libs/sentry';
import { App } from './App.tsx';

initializeSentry();
enableMockServiceWorker();
enableProLicenseMUI();

// eslint-disable-next-line no-useless-assignment
const LDProvider = await initializeLaunchDarkly(
  import.meta.env.VITE_APP_LAUNCHDARKLY_ID,
);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <LDProvider>
      <App />
    </LDProvider>
  </React.StrictMode>,
);
